import React from 'react';
import MembershipSuccess from '../components/MembershipSuccess';

const MembershipSuccessApp = (props) => (
  <MembershipSuccess {...props} />
);

export default MembershipSuccessApp;
